var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1656 0.165604C6.36031 0.165224 6.54901 0.233037 6.69894 0.357271L11.6989 4.52394C12.0533 4.81849 12.1018 5.34455 11.8073 5.69894C11.5127 6.05332 10.9867 6.10182 10.6323 5.80727L6.1656 2.07394L1.69894 5.67394C1.52678 5.81375 1.30599 5.87916 1.08545 5.8557C0.864917 5.83224 0.662831 5.72184 0.523937 5.54894C0.369659 5.37572 0.294558 5.14604 0.316699 4.91514C0.338841 4.68424 0.45622 4.47301 0.640603 4.33227L5.6406 0.307271C5.79484 0.202674 5.97969 0.152795 6.1656 0.165604Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.9741e9666343df7076cc3032456c4b95.svg";
export { ForwardRef as ReactComponent };